/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 10:06:04
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-04-24 11:53:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/index.tsx
 */
import { DropDown, Menu, MenuItem } from '@/src/components/Antd';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import { AdditionalStatus, EOperationType } from '@/src/types/common/order';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
// import { isNumber } from 'src/tools/helper';
import { cloneDeep, get, isNumber } from 'lodash';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import Layout from 'src/layout/DetailPageLayout';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import {
  cancelOrder,
  getOrder,
  getRecipient,
  markAsPaid,
  pickOrder,
  printInvoice,
  saveRecipient,
  undoParcel,
  orderSync,
} from 'src/request/order';
import { getRequestPage } from 'src/request/order/refund';
import { useComponentMemo } from 'src/tools/customHooks';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import {
  EDeliveryType,
  EType,
  IFulfillmentStatus,
  IOrderStatus,
  IPaymentStatus,
} from 'src/types/common/order';
import { modal } from 'src/utils/Modal';
import Customer from '../../Components/Customer';
import MarkAsPaidModal from '../../Components/MarkAsPaid';
import OrderCancelModal from '../../Components/OrderCancelModal';
import OrderInfoRight from '../../Components/OrderInfoRight';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from '../OrderList/config';
import AdditionalItem from './AdditionalItem';
import AdditionalItemCategory from './AdditionalItem/AdditionalItemCategory';
import AdditionalPromoCode from './AdditionalPromoCode';
import InternalInteraction from './InternalInteraction';
import OrderInfo from './OrderInfo';
import OutOfStock from './OutOfStock';
import { ClickAndCollect, PickAndPack, VirtualProduct } from './ParcelProcess';
import ReadyToPick from './ReadyToPick';
import Refund from './Refund';
import RefundDetail from './Refund/Components/RefundDetail';
import ReturnDetails from './Refund/Components/ReturnDetails';
import TermsAndConditionConsent from './TermsAndConditionConsent';
import css from './css.module.less';
import { EExternalRef, breadcrumbData } from './tools';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { getCurrency } from 'src/request/currency';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';

const undo = (uuid, cb) => {
  undoParcel(uuid).then((res) => {
    if (cb) {
      cb(res);
    }
  });
};

const addQuantity = (item) => {
  const { amount } = item;
  return { ...item, quantity: amount };
};
const flattenData = (data) => {
  return data.reduce((pre, now) => {
    const { items } = now;
    const _now = addQuantity(now);

    const isSet = Array.isArray(items);
    if (isSet) {
      const { uuid } = now;
      const children = items.map((item, index, self) => {
        const isLast = self.length === index + 1;

        return {
          ...addQuantity(item),
          [EExternalRef.setUuid]: uuid,
          [EExternalRef.isChild]: true,
          [EExternalRef.isLast]: isLast,
          // [EExternalRef.isChild]: true,
        };
      });
      return [
        ...pre,
        {
          ..._now,
          [EExternalRef.customizationDisplay]: true,
          [EExternalRef.isParent]: true,
        },
        ...children,
      ];
    } else {
      return [...pre, { ..._now, [EExternalRef.customizationDisplay]: true }];
    }
  }, []);
};

const sortData = (simple, set) => {
  const simplePurchase = [];
  const simpleGift = [];
  const setPurchase = [];
  const setGift = [];
  (simple || []).forEach((i) => {
    const { type } = i;
    if (type === EType.Gift) {
      simpleGift.push(i);
    } else {
      simplePurchase.push(i);
    }
  });
  (set || []).forEach((i) => {
    const { type } = i;
    if (type === EType.Gift) {
      setGift.push(i);
    } else {
      setPurchase.push(i);
    }
  });
  return [...simplePurchase, ...setPurchase, ...simpleGift, ...setGift];
};

const pickAndPackDefault = {
  [IFulfillmentStatus.READY_TO_PACK]: [],
  [IFulfillmentStatus.READY_TO_SHIP]: [],

  [IFulfillmentStatus.DELIVERING]: [],
  [IFulfillmentStatus.READY_TO_COLLECT]: [],
  [IFulfillmentStatus.DELIVERED]: [],

  [IFulfillmentStatus.NOTIFIED]: [],
  [IFulfillmentStatus.COLLECTED]: [],
  //[IFulfillmentStatus.READY_TO_SHIP]: [],
};

const permissions = () => {
  const view_order_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.AllOrders,
        operation: EnumOperation.view_order_details_page,
      }),
    ],
  });
  const pick_pack_ship = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderFulfillment,
        operation: EnumOperation.pick_pack_ship,
      }),
    ],
  });
  const click_collect = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderFulfillment,
        operation: EnumOperation.click_collect,
      }),
    ],
  });
  const view_edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCustomer,
        operation: EnumOperation.view_edit_customer_info,
      }),
    ],
  });
  const mark_as_paid_bank_transfer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderPayment,
        operation: EnumOperation.mark_as_paid_bank_transfer,
      }),
    ],
  });
  const mark_as_paid_manual = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderPayment,
        operation: EnumOperation.mark_as_paid_manual,
      }),
    ],
  });
  const create_edit_refund = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.create_edit_refund,
      }),
    ],
  });
  const create_edit_return = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderReturn,
        operation: EnumOperation.create_edit_return,
      }),
    ],
  });
  const cancel_order = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCancellation,
        operation: EnumOperation.cancel_order,
      }),
    ],
  });
  const create_edit_request = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderAdditionalItem,
        operation: EnumOperation.create_edit_request,
      }),
    ],
  });
  const manual_sync = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderSync,
        operation: EnumOperation.manual_sync,
      }),
    ],
  });
  return {
    view_order_details_page,
    pick_pack_ship,
    view_edit_customer_info,
    mark_as_paid_bank_transfer,
    create_edit_refund,
    create_edit_return,
    cancel_order,
    create_edit_request,
    mark_as_paid_manual,
    click_collect,
    manual_sync,
  };
};

const isShowMarsAsPaid = (
  orderStatus: IOrderStatus,
  paymentStatus: IPaymentStatus,
): boolean => {
  const availableOrderStatus = [
    IOrderStatus.DRAFT,
    IOrderStatus.SAVED,
    IOrderStatus.ACTIVE,
  ];
  const availablePaymentStatus = [
    IPaymentStatus.NONE,
    IPaymentStatus.FAILED,
    IPaymentStatus.PENDING,
  ];

  return (
    availableOrderStatus.includes(orderStatus) &&
    availablePaymentStatus.includes(paymentStatus)
  );
};
const Detail = (props) => {
  const { data: currency } = useRequest(getCurrency);
  const storeDecimalPosition = get(currency, 'decimalPosition');
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    view_order_details_page,
    pick_pack_ship,
    view_edit_customer_info,
    mark_as_paid_bank_transfer,
    create_edit_refund,
    create_edit_return,
    cancel_order,
    create_edit_request,
    mark_as_paid_manual,
    click_collect,
    manual_sync,
  } = permissions();
  const { modalOp } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
    // cRef,
  } = modalOp;
  const { uuid }: any = useParams();
  const history = useHistory();
  // const refundRef = useRef();

  const [data, setData] = React.useState<any>(null);
  const [readyToPickItems, setReadyToPickItems] = React.useState([]);
  const [interaction, setInteraction] = React.useState([]);
  const [tacs, setTacs] = React.useState([]);
  const [orderInfo, setOrderInfo] = React.useState({});
  const [customerDetail, setCustomerDetail] = React.useState({});
  const [orderDetail, setOrderDetail] = React.useState({});

  const [outOfStockItems, setOutOfStockItems] = React.useState([]);
  const [salesChannelTimezoneInGmt, setSalesChannelTimezoneInGmt] =
    React.useState(null);
  const [pickAndPackItems, setPickAndPackItems] = React.useState({
    ...pickAndPackDefault,
  });
  const orderNo = get(data, 'orderNo');
  const logisticsMethod = get(data, 'logisticsMethod');
  const buyerName = get(data, 'buyerName');
  const pickupLocation = get(data, 'pickupLocation');
  const collectShop = get(data, 'pickupLocation.locationName');
  const collectDate = get(data, 'pickupLocation.pickupDate');
  const pickupPersonName = get(data, 'recipientName');
  const recipientPhoneNo = get(data, 'recipientPhoneNo');
  const totalPrice = get(data, 'totalPrice');
  const customerPaid = get(data, 'customerPaid');
  const transactionInfo = get(data, 'transactionInfo');
  const currencyCode = get(data, 'currencyCode', '');
  const orderReturns = get(data, 'orderReturns', []);
  const buyerEmail = get(data, 'buyerEmail');
  const buyerPhoneNo = get(data, 'buyerPhoneNo');
  const areaCodes = get(data, 'areaCodes');
  const buyerAreaCodeInfo = get(data, 'buyerAreaCodeInfo');
  const buyerMobile = get(data, 'buyerMobile');
  const crossBoarder = get(data, 'crossBoarder');
  const salesChannelUuid = get(data, 'salesChannelUuid');
  const taxIncluded = get(data, 'taxIncluded');
  const salesChannels = useSelector(getSalesChannels()) || [];
  const storeSetting = useSelector(getBasicSetting()) || {};
  const thirdPartyCallbackEnabled =
    storeSetting?.thirdPartyCallbackEnabled || false;
  const currentSalesChannel = salesChannels.find(
    (i) => i.uuid === salesChannelUuid,
  );
  const decimalPosition = isNumber(get(currentSalesChannel, 'decimalPosition'))
    ? get(currentSalesChannel, 'decimalPosition')
    : 2;

  const additionalPromotionCodes = get(data, 'additionalPromotionCodes', []);
  const orderAdditionalItemRequests = get(
    data,
    'orderAdditionalItemRequests',
    [],
  );
  const parcelSender = get(data, 'parcelSender');
  const orderStatus = get(data, 'orderStatus');
  const paymentStatus = get(data, 'paymentStatus');
  const showInvoice = get(data, 'showInvoice');
  const invoice = get(data, 'invoice');
  const languageCode = get(data, 'languageCode');
  const virtualItems = get(data, 'virtualItems', []);
  const orderCancelJudgement = get(data, 'orderCancelJudgement', {});
  const requestedOrderAdditionalItems = (
    orderAdditionalItemRequests || []
  ).filter((o) => o.status == AdditionalStatus.Requested);
  const pickedItems = get(
    pickAndPackItems,
    IFulfillmentStatus.READY_TO_PACK,
    [],
  );

  const assData = (data) => {
    const {
      accessCode,
      amount = '',
      totalPrice = '',
      discounts = [],
      taxes = [],
      orderLineItems = [],
      comments = '',
      shippingPrice = '',
      salesRepresent = '',
      giftCards = [],
      billingAddress = '',
      billingAddressLine1 = '',
      billingAddressLine2 = '',
      buyerEmail = '',
      buyerFirstName = '',
      buyerLastName = '',
      buyerName = '',
      buyerPhoneNo = '',
      recipientEmail = '',
      recipientFirstName = '',
      recipientLastName = '',
      recipientName = '',
      recipientPhoneNo = '',
      reportingOrderTime = '',
      salesChannelOrderTime = '',
      orderStatus = '',
      paymentStatus = '',
      fulfillmentStatus = '',
      salesChannelName = '',
      warehouseName = '',
      shippingAddress = '',
      shippingAddressLine1 = '',
      shippingAddressLine2 = '',
      userRemarks = '',
      internalRemark = '',
      orderNo = '',
      registered = '',
      customerInteractions = [],
      uuid: orderUuid = '',
      salesChannelTimezoneInGmt = '',
      reportingTimezoneInGmt = '',
      transactionInfo,
      customerPaid,
      payablePrice = '',
      languageCode = '',
      currencyCode = '',
      shippingTaxes = [],
      refundSummary = {},
      subTotal = '',
      taxIncluded = '',
      logisticsMethod = '',
      pickupLocation,
      gatewayProvider,
      earliestShippingDate,
      containPayUpFront,
      firstOrder,
      processingFee,
    } = data;
    const { items: refundSummaryItems = [] } = refundSummary || {};
    const { paymentDetail = {} } = transactionInfo || {};
    setSalesChannelTimezoneInGmt(salesChannelTimezoneInGmt);
    setData(data);
    const _outOfStockSet = get(data, 'outOfStockItems.setItems') || [];
    const _outOfStockSimple = get(data, 'outOfStockItems.simpleItems') || [];
    const _outOfStockItems = flattenData(
      sortData(_outOfStockSet, _outOfStockSimple),
    );
    setOutOfStockItems(_outOfStockItems);
    //===================
    const _readyToPickSet = get(data, 'readyToPickItems.setItems') || [];
    const _readyToPickSimple = get(data, 'readyToPickItems.simpleItems') || [];

    const _readyToPickItems = flattenData(
      sortData(_readyToPickSimple, _readyToPickSet),
    );
    // .filter((i) => {
    //   if (i[EExternalRef.isChild] && i.amount === 0) {
    //     return false;
    //   }
    //   return true;
    // });
    setReadyToPickItems(_readyToPickItems);
    //===================
    const _allParcels = get(data, 'parcels') || [];
    const _readyToPack = _allParcels.reduce(
      (o, p) => {
        const { status } = p;
        if (o[status]) {
          return { ...o, [status]: [...(o[status] || []), p] };
        } else {
          return { ...o, [status]: [p] };
        }
      },
      {
        ...pickAndPackDefault,
      },
    );
    setPickAndPackItems(_readyToPack);
    const _interaction = get(data, 'internalInteractions') || [];
    setInteraction(_interaction);
    const _tacs = get(data, 'tacs') || [];
    setTacs(_tacs);
    const _orderInfo = {
      processingFee,
      amount,
      subTotal,
      totalPrice,
      payablePrice,
      discounts,
      taxes,
      orderLineItems,
      comments,
      shippingPrice,
      shippingTaxes,
      giftCards,
      transactionInfo,
      customerPaid,
      paymentStatus,
      paymentDetail,
      taxIncluded,
      logisticsMethod,
      refundSummary: refundSummaryItems,
      gatewayProvider,
      containPayUpFront,
      firstOrder,
    };
    setOrderInfo(_orderInfo);

    const _customerDetail = {
      billingAddress,
      billingAddressLine1,
      billingAddressLine2,
      buyerEmail,
      buyerFirstName,
      buyerLastName,
      buyerName,
      buyerPhoneNo,
      recipientEmail,
      recipientFirstName,
      recipientLastName,
      recipientName,
      recipientPhoneNo,
      registered,
      userRemarks,
      internalRemark,
      shippingAddress,
      shippingAddressLine1,
      shippingAddressLine2,
      orderUuid,
      customerInteractions,
      languageCode,
      logisticsMethod,
      pickupLocation,
    };

    setCustomerDetail(_customerDetail);
    const _orderDetail = {
      accessCode,
      orderNo,
      orderUuid,
      currencyCode,
      reportingOrderTime,
      salesChannelOrderTime,
      status: [
        { status: orderStatus, calculate: statusText },
        { status: paymentStatus, calculate: paymentStatusText },
        { status: fulfillmentStatus, calculate: fulfillmentStatusesText },
      ],
      salesChannelName,
      warehouseName,
      salesChannelTimezoneInGmt,
      reportingTimezoneInGmt,
      salesRepresent,
      earliestShippingDate,
      containPayUpFront,
    };
    setOrderDetail(_orderDetail);
    //====================
  };

  const { run: _cancelOrder } = useRequest(
    (data) => cancelOrder({ ...data, orderUuid: uuid }),
    {
      manual: true,
      onSuccess: () => {
        msg.success(getI18n('allOrders.orderDetail.index_canceledsuccess'));
        closeModal();
        handelLoadOrderPage();
      },
    },
  );

  const { run: _markAsPaid } = useRequest((data) => markAsPaid(uuid, data), {
    manual: true,
    onSuccess: () => {
      // msg.success('Canceled Successful');
      closeModal();
      handelLoadOrderPage();
    },
  });

  const { run: _getRequestPage } = useRequest(
    (type) => getRequestPage(uuid, type),
    {
      manual: true,
      onSuccess(res, params: any) {
        const { returnNo } = res;
        if ((params[1] || []).length) {
          res.items.forEach((item) => {
            if ((params[1] || []).includes(item.uuid)) {
              item.checked = true;
            }
          });
        }
        setShowModal(true);
        setWidth(973);
        setModalTitle(
          `${params[0]} ${getI18n(
            'allOrders.orderDetail.details',
          )} #${orderNo}-${returnNo}`,
        );
        setModalContent(
          params[0] === EOperationType.Refund ? (
            <RefundDetail
              // disabled
              refundDetail={res}
              areaCodes={areaCodes}
              currencyCode={currencyCode}
              orderUuid={uuid}
              onUpdate={assData}
              onModalCancel={onModalCancel}
              orderBuyerEmail={buyerEmail}
              buyerAreaCodeInfo={buyerAreaCodeInfo}
              buyerMobile={buyerMobile}
              storeDecimalPosition={storeDecimalPosition}
              decimalPosition={decimalPosition}
            />
          ) : (
            <ReturnDetails
              onUpdate={assData}
              returnDetail={res}
              orderUuid={uuid}
              disabled={false}
              onModalCancel={onModalCancel}
              decimalPosition={decimalPosition}
            />
          ),
        );
      },
    },
  );

  const { run: _orderSync, loading: orderSyncLoading } = useRequest(
    () => orderSync(uuid),
    {
      manual: true,
      onSuccess: () => {
        msg.success(getI18n('general.savesuccess'));
      },
    },
  );

  React.useEffect(() => {
    handelLoadOrderPage();
  }, []);

  const handelLoadOrderPage = () => {
    getOrder(uuid).then((res) => {
      assData(res);
    });
  };
  const handleOnPickItems = (items, cb) => {
    const body = { orderUuid: uuid, parcelItems: items };
    pickOrder(body).then((res) => {
      msg.success(getI18n('allOrders.orderDetail.orderhasupdated'));
      assData(res);
      if (cb) cb();
    });
  };

  const _OutOfStock = useComponentMemo(<OutOfStock data={outOfStockItems} />, [
    outOfStockItems,
  ]);
  const _ReadyToPick = useComponentMemo(
    <ReadyToPick
      decimalPosition={decimalPosition}
      data={readyToPickItems}
      taxIncluded={taxIncluded}
      onPickItems={handleOnPickItems}
      disabled={orderStatus === IOrderStatus.CANCELLED || !pick_pack_ship}
      onQuantityPickAll={setReadyToPickItems}
      onQuantityChange={(quantity, index, uuid) => {
        const _readyToPickItems = cloneDeep(readyToPickItems || []);
        (_readyToPickItems[index] || {}).quantity = Number(quantity) || 0;
        setReadyToPickItems(_readyToPickItems);
      }}
    />,
    [readyToPickItems, orderStatus, decimalPosition, taxIncluded],
  );

  const _PickAndPack = useComponentMemo(
    <PickAndPack
      orderNo={orderNo}
      decimalPosition={decimalPosition}
      taxIncluded={taxIncluded}
      data={pickAndPackItems}
      disabled={orderStatus === IOrderStatus.CANCELLED || !pick_pack_ship}
      onUpdate={assData}
      onUndo={undo}
      disablePrint={!view_order_details_page}
    />,
    [orderNo, pickAndPackItems, orderStatus, decimalPosition, taxIncluded],
  );

  const _VirtualProduct = useComponentMemo(
    <VirtualProduct
      getRequestPage={_getRequestPage}
      disabled={orderStatus === IOrderStatus.CANCELLED || !pick_pack_ship}
      virtualItems={virtualItems}
      onUpdate={assData}
    />,
    [virtualItems],
  );

  const _ClickAndCollect = useComponentMemo(
    <ClickAndCollect
      orderNo={orderNo}
      data={pickAndPackItems}
      onUpdate={assData}
      onUndo={undo}
      collectShop={collectShop}
      buyerName={buyerName}
      collectDate={collectDate}
      pickupLocation={pickupLocation}
      disabled={
        orderStatus === IOrderStatus.CANCELLED ||
        paymentStatus === IPaymentStatus.REFUNDED ||
        !pick_pack_ship
      }
      returnFun={() => _getRequestPage(EOperationType.Return)}
      recipientPhoneNo={recipientPhoneNo}
      pickupPersonName={pickupPersonName}
      transactionInfo={transactionInfo}
      customerPaid={customerPaid}
      totalPrice={totalPrice}
      disablePrint={!view_order_details_page}
      disabledClickAndCollect={!click_collect}
    />,
    [
      orderNo,
      pickAndPackItems,
      pickupPersonName,
      orderStatus,
      buyerName,
      click_collect,
    ],
  );

  const _OrderInfo = useComponentMemo(
    <OrderInfo
      orderInfo={orderInfo}
      orderUuid={uuid}
      onUpdate={assData}
      markAsPaidDiabled={!mark_as_paid_bank_transfer}
      decimalPosition={decimalPosition}
      salesChannelTimezoneInGmt={salesChannelTimezoneInGmt}
    />,
    [orderNo, decimalPosition, orderInfo],
  );

  const _AdditionalItemCategory = useComponentMemo(
    requestedOrderAdditionalItems.map((item, index) => (
      <AdditionalItemCategory
        data={item}
        key={index}
        orderNo={orderNo}
        disabled={
          orderStatus === IOrderStatus.CANCELLED || !create_edit_request
        }
        orderUuid={uuid}
        salesChannelUuid={salesChannelUuid}
        onUpdate={assData}
        currencyCode={currencyCode}
      />
    )),
    [orderNo, requestedOrderAdditionalItems, orderStatus, currencyCode],
  );

  const _TermsAndConditionConsent = useComponentMemo(
    <TermsAndConditionConsent
      tacs={tacs}
      salesChannelTimezoneInGmt={salesChannelTimezoneInGmt}
    />,
    [orderNo, salesChannelTimezoneInGmt, tacs],
  );

  const _InternalInteraction = useComponentMemo(
    <InternalInteraction interaction={interaction} />,
    [orderNo, , interaction],
  );
  const _AdditionalItem = useComponentMemo(
    <AdditionalItem
      salesChannelUuid={salesChannelUuid}
      currency={currencyCode}
      orderUuid={uuid}
      disable={
        (pickedItems || []).length ||
        orderStatus === IOrderStatus.CANCELLED ||
        !create_edit_request
      }
      onUpdate={assData}
    />,
    [salesChannelUuid, pickedItems, currencyCode],
  );

  const _additionalPromoCode = useComponentMemo(
    <AdditionalPromoCode
      orderUuid={uuid}
      onUpdate={assData}
      disabled={orderStatus === IOrderStatus.CANCELLED}
      additionalPromotionCodes={additionalPromotionCodes}
    />,
    [additionalPromotionCodes],
  );

  const _OrderInfoRight = useComponentMemo(
    <OrderInfoRight
      orderDetail={{
        ...orderDetail,
        orderTimeTitle: getI18n('allOrders.orderDetail.index_ordertime'),
      }}
      title={`${getI18n('allOrders.orderDetail.order')} ${orderNo ? '#' : ''}${
        orderNo || ''
      }`}
      reLoadOrderPage={handelLoadOrderPage}
    />,
    [orderNo, orderDetail],
  );

  const _Customer = useComponentMemo(
    <Customer
      // buildData={123}
      languageCode={languageCode}
      customerDetail={customerDetail}
      crossBoarder={crossBoarder}
      orderUuid={uuid}
      invoice={invoice}
      disabled={
        orderStatus === IOrderStatus.CANCELLED || !view_edit_customer_info
      }
      showInvoice={showInvoice}
      getRecipientReq={getRecipient}
      saveRecipientReq={saveRecipient}
      reLoadOrderPage={handelLoadOrderPage}
      parcelSender={parcelSender}
      pickupInfo={
        get(data, 'logisticsMethod') === EDeliveryType.ClickCollect
          ? {
              ...(get(data, 'pickupLocation') || {}),
              pickupDate: get(data, 'pickupDate'),
            }
          : null
      }
    />,
    [orderNo, customerDetail],
  );

  const renderDelivery = () => {
    return <Element>{_PickAndPack}</Element>;
  };

  const renderCollect = () => {
    return <Element>{_ClickAndCollect}</Element>;
  };

  const _distributionPart = () => {
    const pickAndPackItemsLength =
      Object.values(pickAndPackItems).flat(Infinity);
    if (
      logisticsMethod === EDeliveryType.ClickCollect &&
      pickAndPackItemsLength.length
    ) {
      return renderCollect();
    }
    if (
      logisticsMethod === EDeliveryType.Delivery &&
      pickAndPackItemsLength.length
    ) {
      return renderDelivery();
      // return renderCollect(); //for mock data
    }
    if (
      logisticsMethod === EDeliveryType.ParcelLocker &&
      pickAndPackItemsLength.length
    ) {
      return renderDelivery();
    }
    return null;
  };
  const beforeGoBack = () => {
    history.push('/orderList');
  };

  // const topLeft = <div>2222</div>;

  const leftGenerate = () => {
    return (
      <React.Fragment>
        {(orderReturns || []).map((item, index) => (
          <Element key={index}>
            <Refund
              type={item.type}
              status={item.status}
              phase={item.phase}
              orderReturn={item}
              currencyCode={currencyCode}
              orderNo={orderNo}
              onUpdate={assData}
              buyerEmail={buyerEmail}
              areaCodes={areaCodes}
              buyerPhoneNo={buyerPhoneNo}
              buyerAreaCodeInfo={buyerAreaCodeInfo}
              buyerMobile={buyerMobile}
              salesChannelUuid={salesChannelUuid}
              salesChannelDecimalPosition={decimalPosition}
            />
          </Element>
        ))}

        {(requestedOrderAdditionalItems || []).length ? (
          <Element>{_AdditionalItemCategory}</Element>
        ) : null}
        {(outOfStockItems || []).length > 0 && <Element>{_OutOfStock}</Element>}
        {(readyToPickItems || []).length ? (
          <Element>{_ReadyToPick}</Element>
        ) : null}
        {(virtualItems || []).length > 0 && (
          <Element>{_VirtualProduct}</Element>
        )}
        {_distributionPart()}
        <Element>{_OrderInfo}</Element>
        {!requestedOrderAdditionalItems.length ? (
          <Element>{_AdditionalItem}</Element>
        ) : null}
        <Element>{_additionalPromoCode}</Element>
        {interaction.length ? <Element>{_InternalInteraction}</Element> : null}
        <Element>{_TermsAndConditionConsent}</Element>
      </React.Fragment>
    );
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const handleOrderCancel = () => {
    if (orderCancelJudgement.cancelable) {
      setShowModal(true);
      setWidth(600);
      setModalTitle(getI18n('allOrders.orderDetail.cancelorder'));
      setModalContent(
        <OrderCancelModal
          onModalCancel={closeModal}
          cancelOrder={_cancelOrder}
          disabledRestock={orderStatus === IOrderStatus.DRAFT}
        />,
      );
    } else {
      modal.error({
        title: getI18n('allOrders.orderDetail.handleOrderCancel_error_title'),
        content: getI18n(
          'allOrders.orderDetail.handleOrderCancel_error_content',
        ),
        onCancelText: getI18n(
          'allOrders.orderDetail.handleOrderCancel_error_onCancelText',
        ),
        onCancel: () => void 0,
      });
    }
  };
  const onMarkAsPaidConfirm = (values) => {
    const { reason } = values;
    _markAsPaid({ remark: reason, paymentReference: reason });
  };
  const handleMarkAsPaid = () => {
    setShowModal(true);
    setWidth(600);
    setModalTitle(getI18n('allOrders.orderDetail.markasPaid'));
    setModalContent(
      <MarkAsPaidModal
        onModalCancel={closeModal}
        onMarkAsPaidConfirm={onMarkAsPaidConfirm}
      />,
    );
  };

  const overlay = (
    <Menu>
      <MenuItem
        className={css.menuItem}
        onClick={() => _getRequestPage(EOperationType.Refund)}
        disabled={!create_edit_refund}>
        {getI18n('allOrders.orderDetail.overlay_refund')}
      </MenuItem>
      <MenuItem
        className={css.menuItem}
        onClick={() => _getRequestPage(EOperationType.Return)}
        disabled={!create_edit_return}>
        {getI18n(
          'allOrders.orderDetail.collected_return_category_dropoptions_label',
        )}
      </MenuItem>
      <MenuItem
        className={css.menuItem}
        onClick={handleOrderCancel}
        disabled={!cancel_order}>
        {getI18n('allOrders.orderDetail.overlay_cancelorder')}
      </MenuItem>
      {isShowMarsAsPaid(orderStatus, paymentStatus) ? (
        <MenuItem
          className={css.menuItem}
          onClick={handleMarkAsPaid}
          disabled={!mark_as_paid_manual}>
          {getI18n('allOrders.orderDetail.markasPaid')}
        </MenuItem>
      ) : null}
      {thirdPartyCallbackEnabled && (
        <MenuItem
          className={css.menuItem}
          onClick={_orderSync}
          disabled={!manual_sync || orderSyncLoading}>
          {getI18n('allOrders.orderDetail.manualSync')}
        </MenuItem>
      )}
    </Menu>
  );

  return (
    <Layout
      leftPart={leftGenerate()}
      header={
        <div className={css.header}>
          <TopLeft
            goBack={beforeGoBack}
            breadcrumbData={breadcrumbData(orderNo, { getI18n })}
          />
          <TopRight
            extendButton={
              <Fragment>
                <div
                  onClick={() =>
                    printInvoice({
                      orderUuids: [uuid],
                      pageSize: 'A4',
                    })
                  }
                  className={css.printInvoice}>
                  <Icon type='icondown' />
                  {getI18n('allOrders.orderDetail.return_print_invoice')}
                </div>
                {orderStatus !== IOrderStatus.CANCELLED && (
                  <DropDown.Button
                    icon={<Icon type='icondown' />}
                    className={css.extendButton}
                    overlay={overlay}
                    placement='bottomRight'
                    trigger={['click']}>
                    {getI18n('allOrders.orderDetail.return_more_actions')}
                  </DropDown.Button>
                )}
              </Fragment>
            }
          />
        </div>
      }
      rightElements={[
        { child: _OrderInfoRight },
        {
          child: _Customer,
        },
      ]}
    />
  );
};

export default ModalHoc(Detail);
//  (get(data, 'readyToPickItems') || []).map((i) => {
//   const { uuid, amount } = i;
//   const _previous = readyToPickItems.find((i) => (i.uuid = uuid));
//   const _preQuantity = get(_previous, 'quantity');
//   if (isNumber(_preQuantity)) {
//     if (_preQuantity < 1) {
//       return { ...i, quantity: amount };
//     }
//     if (_preQuantity > amount) {
//       return { ...i, quantity: amount };
//     }
//     return { ...i, quantity: _preQuantity };
//   } else {
//     return { ...i, quantity: amount };
//   }
// });
